"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = __importDefault(require("../Button"));
const Surplus = ({ label, step = 1, max = null, min = 0, ...props }) => {
    const [field, { error, value }, helpers] = (0, formik_1.useField)(props.name);
    const { setValue } = helpers;
    const id = props.id ? props.id : props.name;
    const { 
    // @ts-ignore
    values: { quantity, surplus }, touched, setFieldValue } = (0, formik_1.useFormikContext)();
    (0, react_1.useEffect)(() => {
        if (
        // @ts-ignore
        quantity < surplus) {
            setFieldValue('surplus', quantity);
        }
        // @ts-ignore
    }, [quantity, touched.quantity, setFieldValue, props.name]);
    const changeValue = (delta) => {
        const newValue = value + delta;
        if (newValue > quantity) {
            return;
        }
        if (newValue < min) {
            return;
        }
        setFieldValue('surplus', newValue);
    };
    const handleInputChange = (e) => {
        const newValue = e.target.value;
        if (newValue > quantity) {
            setValue(quantity);
            return;
        }
        if (newValue < min) {
            console.log('max', min);
            setValue(min);
            return;
        }
        setFieldValue('surplus', newValue);
    };
    return (react_1.default.createElement("div", { className: "space-y-1" },
        react_1.default.createElement("label", { htmlFor: id, className: "block text-sm font-medium text-gray-700" }, label),
        react_1.default.createElement("div", { className: "mt-1 relative rounded-md shadow-sm" },
            react_1.default.createElement("div", { className: 'flex' },
                react_1.default.createElement(Button_1.default, { type: "button", className: 'text-3xl mr-4', onClick: () => changeValue(-step) }, "-"),
                react_1.default.createElement("input", { ...props, ...field, onBlur: handleInputChange, type: 'number', id: id, className: (0, classnames_1.default)("form-input ignore-scan", error ? '--error' : '') }),
                react_1.default.createElement(Button_1.default, { type: "button", className: 'text-3xl ml-4', onClick: () => changeValue(step) }, "+")),
            touched && error ? (react_1.default.createElement("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" },
                react_1.default.createElement("svg", { className: "h-5 w-5 text-red-500", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" },
                    react_1.default.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z", clipRule: "evenodd" })))) : null),
        touched && error ? react_1.default.createElement("p", { className: "mt-2 text-sm text-red-600", id: "email-error" }, error[0]) : ''));
};
exports.default = Surplus;
